import { BaseService, Service } from "/@/cool";

@Service("orderGroup")
class OrderGroup extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}
		this.permission["create"] = prefix + "create";
		this.permission["page"] = prefix + "page";
		this.permission["info"] = prefix + "info";
		this.permission["dissolve"] = prefix + "dissolve";
		this.permission["remove"] = prefix + "remove";
	}

	create(data: { order_ids: number[]; submit_modeling?: boolean }) {
		return this.request({
			url: "/create",
			method: "POST",
			data
		});
	}

	dissolve(data: { id: number }) {
		return this.request({
			url: "/dissolve",
			method: "POST",
			data
		});
	}

	remove(data: { id: number; order_ids: number[] }) {
		return this.request({
			url: "/remove",
			method: "POST",
			data
		});
	}
}

export default OrderGroup;
